"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toLowerCaseString_1 = __importDefault(require("./toLowerCaseString"));
var fuzzyscore = function (needle, haystack) {
    // returns a score, 0 being no match, 100 being perfect
    needle = toLowerCaseString_1.default(needle);
    haystack = toLowerCaseString_1.default(haystack);
    if (haystack === needle) {
        return 100;
    }
    var score = 0;
    if (haystack.indexOf(needle) >= 0) {
        score += 50;
    }
    return score;
};
exports.default = fuzzyscore;
